import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import AsResponsiveContent from '../airship-wrappers/AsResponsiveContent';
import AsLegendCategory from '../airship-wrappers/AsLegendCategory';
import DpsCategoryWidget from '../DpsCategoryWidget';
import DpsLayerToggle from '../DpsLayerToggle';
import DpsLegendCategory from '../DpsLegendCategory';
import DpsActiveFilters from '../DpsActiveFilters';
import * as layers from '../../layers';
import DpsQueryModifier from '../DpsQueryModifier';
import { MAP_CONFIG } from '../../MAP_CONFIG';
import { withCarto } from '../../carto/withCarto';
import DpsLoadingIndicator from '../DpsLoadingIndicator';

export class Infrastructure extends Component {
  state = {
    ready: false,
    infrastructurePoints: undefined,
    infrastructureLines: undefined,
    isLoadingPoints: true,
    isLoadingLines: true,
  }

  selectedPointsLayers = ["infrastructurePoints", "infrastructurePointsSum"]
  selectedLinesLayers = ["infrastructureLines", "infrastructureLinesSum"]
  categoryLayers = [ "infrastructureLinesTypes", "infrastructurePointsCategories", "infrastructurePointsTypes"]
  selectedLayers = [...this.selectedPointsLayers, ...this.selectedLinesLayers, ...this.categoryLayers]

  constructor(props) {
    super(props)
    this.categoryWidget = React.createRef()
    this.categoryWidgetCIType = React.createRef()
    this.categoryWidgetLifelineType = React.createRef()
  }

  componentDidMount() {
    this.props.CartoContext.initCarto()
  }

  componentWillUnmount() {
    if (this.state.ready) {
      this.props.CartoContext.dataviews['infrastructurePointsSum'].off('dataChanged', this.updateinfrastructurePoints)
      this.props.CartoContext.dataviews['infrastructureLinesSum'].off('dataChanged', this.updateinfrastructureLines)
      this.props.CartoContext.resetLayers()
    }
  }

  onReady = () => {
    this.props.CartoContext.loadMap(MAP_CONFIG)
    this.props.CartoContext.loadLayers([
      {...layers.wildfire, hide: true},
      {...layers.flood, hide: true},
      {...layers.damInundation, hide: true},
      {...layers.landslide, hide: true},
      {...layers.tsunami, hide: true},
      {...layers.levee, hide: true},
      {...layers.eq1, hide: true},
      {...layers.eq2, hide: true},
      {...layers.slr, hide: true},
      {...layers.infrastructureLines, index: 7, callback: this.updateLinesLoaded},
      {...layers.infrastructurePoints, index: 8, callback: this.updatePointsLoaded},
      layers.municipality,
      layers.kernCounty,
    ])
    this.props.CartoContext.loadDataview(layers.infrastructureLinesTypes)
    this.props.CartoContext.loadDataview(layers.infrastructureLinesSum)
    this.props.CartoContext.loadDataview(layers.infrastructurePointsCategories)
    this.props.CartoContext.loadDataview(layers.infrastructurePointsTypes)
    this.props.CartoContext.loadDataview(layers.infrastructurePointsSum)
    this.props.CartoContext.addToMap()
    this.props.CartoContext.addPopup('infrastructurePoints', 'featureClicked', this.popupContentPoints)
    this.props.CartoContext.addPopup('infrastructureLines', 'featureClicked', this.popupContentLines)
    this.props.CartoContext.dataviews['infrastructurePointsSum'].on('dataChanged', this.updateinfrastructurePoints)
    this.props.CartoContext.dataviews['infrastructureLinesSum'].on('dataChanged', this.updateinfrastructureLines)

    this.setState(state => ({ ...state, ready: true }))
  }

  updatePointsLoaded = (loaded) => {
    this.setState(state => ({
      ...state,
      isLoadingPoints: loaded !== 'loaded'
    }))
  }

  updateLinesLoaded = (loaded) => {
    this.setState(state => ({
      ...state,
      isLoadingLines: loaded !== 'loaded'
    }))
  }

  popupContentPoints = (vars) => (`
    <div style="max-height: 200px; overflow: scroll;">${
          [
            {
              label: 'Municipality',
              value: vars.mun
            },
            {
              label: 'Asset Type',
              value: vars.lyr_name
            },
            {
              label: 'Name',
              value: vars.name
            },
            {
              label: 'Asset',
              value: vars.lyr_sub
            },
            // {
            //   label: 'Asset Desc.',
            //   value: vars.lyr_subwp
            // },
            {
              label: 'School District',
              value: vars.district
            },
            {
              label: 'Address',
              value: vars.address
            },
            {
              label: 'Asset Level',
              value: vars.lyr_cat
            },
            // {
            //   label: 'Insured Category',
            //   value: vars.inscat
            // },
            // {
            //   label: 'Insured Subcategory',
            //   value: vars.inssubcat
            // },
            {
              label: 'Wildfire Risk Area',
              value: vars.haz_wf
            },
            {
              label: 'M6.8 Concord Green Valley',
              value: vars.haz_eq1
            },
            {
              label: 'M7.1 Hayward Rodgers Creek',
              value: vars.haz_eq2
            },
            {
              label: 'FEMA Flood Zone Area',
              value: vars.haz_fld
            },
            // {
            //   label: 'FEMA Flood Sub Type Area',
            //   value: vars.haz_fldsub
            // },
            {
              label: 'Dam Inundation Area',
              value: vars.haz_damg
            },
            {
              label: 'Area Protected by Levee',
              value: vars.haz_lev
            },
            {
              label: 'Landslide Risk Area (High)',
              value: vars.haz_ls
            },
            {
              label: 'Tsunami Runup Area',
              value: vars.haz_tsu
            },
            {
              label: 'Sea Level Rise Inundation (scenario level - low rise to extreme rise)',
              value: vars.haz_slr
            },
            {
              label: 'Building Value',
              value: '$'+numeral(vars.cost*1000).format('0,0'),
            },
            {
              label: 'Content Value',
              value: '$'+numeral(vars.content*1000).format('0,0'),
            },
          ].map(field => (
            `<small style="opacity: 0.67;">${field.label}</small>
            <p style="margin-top: 0px;" class="description open-sans">${field.value}</p>`
          )).join('')
        }</div>
  `)

  popupContentLines = (vars) => (`
    <div style="max-height: 200px; overflow: scroll;">${
          [
            {
              label: 'Municipality',
              value: vars.mun
            },
            {
              label: 'Asset Type',
              value: vars.lyr_name
            },
            {
              label: 'Name',
              value: vars.name
            },
            {
              label: 'Asset Level',
              value: vars.lyr_cat
            },
            {
              label: 'Wildfire Risk Area',
              value: vars.haz_wf
            },
            {
              label: 'M6.8 Concord Green Valley',
              value: vars.haz_eq1
            },
            {
              label: 'M7.1 Hayward Rodgers Creek',
              value: vars.haz_eq2
            },
            {
              label: 'FEMA Flood Zone Area',
              value: vars.haz_fld
            },
            // {
            //   label: 'FEMA Flood Sub Type Area',
            //   value: vars.haz_fldsub
            // },
            {
              label: 'Dam Inundation Area',
              value: vars.haz_damg
            },
            {
              label: 'Area Protected by Levee',
              value: vars.haz_lev
            },
            {
              label: 'Landslide Risk Area (High)',
              value: vars.haz_ls
            },
            {
              label: 'Tsunami Runup Area',
              value: vars.haz_tsu
            },
            {
              label: 'Sea Level Rise Inundation (scenario level - low rise to extreme rise)',
              value: vars.haz_slr
            },

          ].map(field => (
            `<small style="opacity: 0.67;">${field.label}</small>
            <p style="margin-top: 0px;" class="description open-sans">${field.value}</p>`
          )).join('')
        }</div>
  `)

  updateinfrastructurePoints = (data) => {
    this.setState(state => ({
      ...state,
      infrastructurePoints:  data.result,
    }))
  }

  updateinfrastructureLines = (data) => {
    this.setState(state => ({
      ...state,
      infrastructureLines:  data.result,
    }))
  }

  clearFilters = () => {
    this.categoryWidget.current.clearSelection()
    this.categoryWidgetCIType.current.clearSelection()
    this.categoryWidgetLifelineType.current.clearSelection()
    this.selectedLayers.forEach(layer => {
      this.props.CartoContext.clearFilters(layer)
    })
  }

  render() {
    return (
      <AsResponsiveContent onReady={this.onReady}>
        <DpsLoadingIndicator isLoading={this.state.isLoadingPoints || this.state.isLoadingLines}></DpsLoadingIndicator>
        <aside className="as-sidebar as-sidebar--left as-sidebar-ci" data-name="Jurisdiction">
          <div className="as-container as-p--16">
            { 
              this.state.ready && <React.Fragment>
                <DpsCategoryWidget ref={this.categoryWidget} dataview={'infrastructurePointsCategories'} selectedLayers={[...this.selectedPointsLayers, ...this.selectedLinesLayers, "infrastructurePointsTypes", "infrastructureLinesTypes",]} heading="Jurisdiction" field="mun" description="Select CI points and lines in any jurisdictions (point counts shown)"></DpsCategoryWidget>
                <DpsCategoryWidget ref={this.categoryWidgetCIType} dataview={'infrastructurePointsTypes'} selectedLayers={[...this.selectedPointsLayers]} heading="CI Type" field="lyr_name" description="Select CI points by type"></DpsCategoryWidget>
                <DpsCategoryWidget ref={this.categoryWidgetLifelineType} dataview={'infrastructureLinesTypes'} selectedLayers={this.selectedLinesLayers} heading="Lifeline Type" field="lyr_name" description="Select CI lines by type"></DpsCategoryWidget>
              </React.Fragment>
            }
          </div>
        </aside>
        <main className="as-main">
          <div className="as-map-panels" data-name="Layers">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--right">
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <h4 className="as-subheader">Map Hazard Layers</h4>
                <p>Critical Infrastructure</p>
                <DpsLayerToggle label="Points" layer="infrastructurePoints" checked>
                  <as-legend>
                    <DpsLegendCategory layer="infrastructurePoints"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Lines" layer="infrastructureLines" checked>
                  <as-legend>
                    <DpsLegendCategory layer="infrastructureLines"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <p>Hazard Layer</p>
                <DpsLayerToggle label="M6.8 Concord Green Valley" layer="eq1">
                  <as-legend description="M6.8 Concord Green Valley">
                    <DpsLegendCategory layer="eq1"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="M7.1 Hayward Rodgers Creek" layer="eq2">
                  <as-legend description="M7.1 Hayward Rodgers Creek">
                    <DpsLegendCategory layer="eq2"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="FEMA Flood Hazard" layer="flood">
                  <as-legend>
                    <DpsLegendCategory layer="flood"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Dam Inundation" layer="damInundation">
                  <as-legend>
                    <AsLegendCategory slot="legends" orientation="vertical" data={[{type: 'point', color: "#81ccb4", label: "Dam Inundation"}]}></AsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Wildfire" layer="wildfire">
                  <as-legend>
                    <DpsLegendCategory layer="wildfire"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Landslide" layer="landslide">
                  <as-legend>
                    <DpsLegendCategory layer="landslide"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Tsunami Runup Area" layer="tsunami">
                  <as-legend>
                    <DpsLegendCategory layer="tsunami"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Area Protected by Levee" layer="levee">
                  <as-legend>
                    <DpsLegendCategory layer="levee"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Sea Level Rise (By Scenario of Rise)" layer="slr">
                  <as-legend>
                    <DpsLegendCategory layer="slr"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <p>Base Map</p>
                <DpsLayerToggle label="Solano County" layer="kernCounty" checked>
                </DpsLayerToggle>
                <DpsLayerToggle label="Municipality" layer="municipality" checked>
                </DpsLayerToggle>
              </div>
            </div>}
          </div>
          <div className="as-map-panels" data-name="Summary">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--left" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <span> Selected CI Points</span>
                <br />
                <span style={{ margin: 0, fontSize: '1.5em', fontWeight: 'bold' }}>
                  {this.state.infrastructurePoints !== undefined ? numeral(this.state.infrastructurePoints).format('0,0') : 'Loading'}
                </span>
                <br />
                <span> Selected CI Lines</span>
                <br />
                <span style={{ margin: 0, fontSize: '1.5em', fontWeight: 'bold' }}>
                  {this.state.infrastructureLines !== undefined ? numeral(this.state.infrastructureLines).format('0.0a')+' mi' : 'Loading'}
                </span>
              </div>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <DpsQueryModifier label="CI Type Filters" layerNames={this.selectedLayers} field="lyr_cat" values={['Essential Facilities', 'High Potential Loss', 'Transportation and Lifeline', 'Hazmat']}></DpsQueryModifier>
              </div>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <p style={{ marginTop: 0 }}>CI Risk Filters</p>
                <DpsQueryModifier label="M6.8 Concord Green Valley" layerNames={this.selectedLayers} field="haz_eq1" values={['Severe', 'Very Strong', 'Strong']}></DpsQueryModifier>
                <DpsQueryModifier label="M7.1 Hayward Rodgers Creek" layerNames={this.selectedLayers} field="haz_eq2" values={['Severe', 'Very Strong','Strong']}></DpsQueryModifier>
                <DpsQueryModifier label="FEMA Flood Risk" layerNames={this.selectedLayers} field="haz_fld" values={['100yr','100yr Coastal', '500yr', 'PROTECTED BY LEVEE']}></DpsQueryModifier>
                <DpsQueryModifier label="Dam Inundation Risk" layerNames={this.selectedLayers} field="haz_damg" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Wildfire Risk" layerNames={this.selectedLayers} field="haz_wf" values={['Very High', 'High', 'Moderate']}></DpsQueryModifier>
                <DpsQueryModifier label="Landslide Risk" layerNames={this.selectedLayers} field="haz_ls" values={['High', 'Medium', 'Low']}></DpsQueryModifier>
                <DpsQueryModifier label="Tsunami Runup" layerNames={this.selectedLayers} field="haz_tsu" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Area Protected by Levee" layerNames={this.selectedLayers} field="haz_lev" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Sea Level Rise (By Scenario of Rise)" layerNames={this.selectedLayers} field="haz_slr" values={['Low','Intermediate Low','Intermediate','Intermediate High','High','Extreme']}></DpsQueryModifier>
              </div>
              <div className="dps-mx-8">
                <DpsActiveFilters selectedLayers={[{layerName: 'infrastructurePoints', label: 'Selected Points'}, {layerName: 'infrastructureLines', label: 'Selected Lines'}]} minWidth={200}></DpsActiveFilters>
                <button className="as-panel__element as-btn as-btn--complementary" style={{ color: '#FFF', justifyContent: 'center', width: '100%' }} onClick={this.clearFilters}>Clear All Filters</button>
              </div>
            </div>
            }
          </div>
          <div className="as-map-area">
            <div id="map"></div>
          </div>
        </main>
      </AsResponsiveContent >
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(Infrastructure));
